import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { SquaresFour, Package, Folders, Receipt, Crosshair, UsersThree, Gear, Robot, DiscordLogo, ArrowLeft, SignOut, Lightning } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", end: true, label: "Overview", icon: SquaresFour, id: "admin-nav-overview" },
  { to: "/admin/listings", label: "Listings", icon: Package, id: "admin-nav-listings" },
  { to: "/admin/categories", label: "Categories", icon: Folders, id: "admin-nav-categories" },
  { to: "/admin/orders", label: "Orders", icon: Receipt, id: "admin-nav-orders" },
  { to: "/admin/requests", label: "Bounties", icon: Crosshair, id: "admin-nav-requests" },
  { to: "/admin/users", label: "Users", icon: UsersThree, id: "admin-nav-users" },
  { to: "/admin/settings", label: "Settings", icon: Gear, id: "admin-nav-settings" },
  { to: "/admin/discord", label: "Discord", icon: DiscordLogo, id: "admin-nav-discord" },
  { to: "/admin/overpowered", label: "Overpowered", icon: Lightning, id: "admin-nav-overpowered" },
  { to: "/admin/command", label: "Bot Command", icon: Robot, id: "admin-nav-command" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#050505] flex items-center justify-center text-[#777] tracking-[0.3em] uppercase text-xs">Authenticating...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;

  return (
    <div className="admin-shell min-h-screen bg-[#050505] text-white flex" data-testid="admin-layout">
      <aside className="w-[230px] shrink-0 border-r border-[#ff2a55]/30 bg-[#080808] flex flex-col sticky top-0 h-screen">
        <div className="p-5 border-b border-[#ff2a55]/30">
          <img src="/brand/logo.webp" alt="Bomber RSNS" className="w-32" />
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#ff2a55] mt-2 animate-flicker">Command center</div>
        </div>
        <nav className="flex-1 py-3">
          {nav.map((n) => (
            <NavLink key={n.id} to={n.to} end={n.end} data-testid={n.id}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-3 text-xs font-bold tracking-[0.15em] uppercase border-l-2 transition-colors ${isActive ? "border-[#ff2a55] bg-[#ff2a55]/10 text-white" : "border-transparent text-[#888] hover:text-white hover:bg-white/5"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2 text-xs">
          <Link to="/" className="flex items-center gap-2 text-[#888] hover:text-white transition-colors" data-testid="admin-back-to-store"><ArrowLeft size={14} /> View store</Link>
          <button onClick={logout} className="flex items-center gap-2 text-[#888] hover:text-[#ff2a55] transition-colors" data-testid="admin-logout-button"><SignOut size={14} /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 md:p-8 overflow-x-hidden"><Outlet /></main>
    </div>
  );
}

export function PageHead({ title, sub, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 pb-4 border-b border-[#ff2a55]/30">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#ff2a55] mb-1">{sub}</div>
        <h1 className="font-display text-4xl leading-none" data-testid="admin-page-title">{title}</h1>
      </div>
      <div className="flex gap-2 flex-wrap">{children}</div>
    </div>
  );
}
